<template>
  <div>
    <v-container>
      <div v-if="this.is_active === '0' || this.passed === 'no_pass' || this.is_active === null || this.passed === null">
        <div v-if="this.is_active === '0'">
          <div class="main-title" style="color: red">风险评测未通过</div>
        </div>
        <div v-if="this.passed === 'no_pass'">
          <div class="main-title" style="color: red">投资人认证未通过</div>
        </div>
        <div v-if="this.is_active === null">
          <div class="main-title" style="color: red">请先完成风险评测</div>
        </div>
        <div v-if="this.passed === null">
          <div class="main-title" style="color: red">请先完成投资人认证</div>
        </div>
      </div>
      <div v-else>
        <div class="main-title">我的房产</div>
        <v-card v-for="(item, index) in homeInvest.data" :key="index">
          <v-card-title primary-title>
            <div style="font-size: 18px">
              <div>编号：{{ item.id }}</div>
              <div>房产公司：{{ item.title }}</div>
              <div>面积：{{ item.area }}</div>
              <div>价格：{{ item.buy_price }}</div>
              <div>地址：{{ item.address }}</div>
              <div>评分：{{ item.score }}</div>
              <div>入住率：{{ item.live_rate }}</div>
              连结：<a :href="item.link">{{ item.link }}</a>
            </div>
          </v-card-title>
        </v-card>
      </div>

      <v-snackbar :bottom="y === 'bottom'" :color="color" :left="x === 'left'" :right="x === 'right'" :timeout="6000" :top="y === 'top'" v-model="snackbar">
        <div>{{ text }}</div>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Cookies from 'js-cookie'

export default {
  props: {
    is_active: {
      type: String,
      default: false
    },
    passed: {
      type: String,
      default: 'no_pass'
    },
    country: {
      type: String,
      default: 'Europe'
    }
  },
  inject: ['reload'],
  computed: mapGetters({
    homeInvest: 'homeInvest'
  }),
  data() {
    return {
      snackbar: false,
      y: 'top',
      x: null,
      mode: '',
      timeout: 6000,
      text: '',
      color: '',
      valid: false,
      passwordRules: [v => !!v || '请填入密码'],
      emailRules: [v => !!v || '请填入邮箱']
    }
  },
  watch: {
    country: {
      handler(newValue, oldValue) {
        this.fetchData()
      },
      deep: true
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.$store.dispatch('getHomeInvest', {
        token: Cookies.get('member_id'),
        type: this.country
      })
    },
    save() {
      if (this.$refs.form.validate()) {
        let datas = {
          id: this.userData.data.id,
          email: this.userData.data.email,
          password: this.userData.data.password,
          token: this.userData.data.token
        }

        this.snackbar = true
        this.text = '更新成功'
        this.color = 'success'

        this.$store.dispatch('updateUserData', datas).then(() => {
          this.$router.go(0)
        })
      }
    }
  }
}
</script>